module.exports = __webpack_public_path__ + "static/media/star-app.fdbfd04d.svg";